import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { useFetchExtractionsApi } from 'api/extraction'
import { Extraction, ExtractionSearchForm } from 'entities/extraction'
import { GlobalStateContext } from 'contexts/global_state_context'
import { A4 } from 'components/shared/print'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Flex } from 'components/shared/flex'
import { Button, Table } from 'react-bootstrap'
import QRCode from 'qrcode.react'
import lodash from 'lodash'
import { InputField } from 'components/shared/input'

type Props = {
    history: H.History
}

const ExperimentSheetPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<ExtractionSearchForm>()
    const searchForm = useForm<ExtractionSearchForm>(params)
    const api = useFetchExtractionsApi(searchForm)
    const form = useForm<{ note?: string }>({})

    useEffect(() => {
        api.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    const chunks = (): Extraction[][] => {
        return lodash.chunk(api.response.results, 7)
    }

    let count = 0
    return (
        <>
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="flex-end">
                <div style={{ width: 500 }}>
                    <InputField form={form} attr="note" label="メモ(デフォルト印刷用)" as="textarea"></InputField>
                </div>
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </Flex>
            {api.response.results?.length !== 0 &&
                chunks().map((chunk, index) => {
                    return (
                        <A4 padding={5} landscape={false} key={'page' + index}>
                            <Flex style={{ borderBottom: 'solid 1px black', width: 400, padding: 0 }} alignItems="flex-end">
                                <div style={{ fontSize: 11, marginLeft: 50, fontWeight: 'bold' }}>作業日時</div>
                                <div style={{ fontSize: 14, marginLeft: 120 }}>/</div>
                                <div style={{ fontSize: 14, marginLeft: 50 }}>/</div>
                            </Flex>
                            <Flex style={{ marginTop: 10, borderBottom: 'solid 1px black', width: 400, padding: 0 }} alignItems="flex-end">
                                <div style={{ fontSize: 11, marginLeft: 50, fontWeight: 'bold' }}>担当者氏名</div>
                            </Flex>
                            <Table bordered style={{ fontSize: 9, marginTop: 20 }}>
                                <thead>
                                    <tr style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                        <th style={{ width: 10, padding: 0 }}>#</th>
                                        <th style={{ width: 120, transform: 'scale(0.8)', padding: 0 }}>
                                            ExperimentID
                                            <br />
                                            (extractionID)
                                        </th>
                                        <th style={{ width: 70, padding: 0 }}>QR</th>
                                        <th style={{ width: 140, padding: 0, maxWidth: 140 }}>検体情報</th>
                                        <th style={{ minWidth: 200, padding: 0 }}>デバイスLot ID シール貼付欄</th>
                                        <th style={{ width: 180, padding: 0 }}>メモ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chunk.map((extraction, index) => {
                                        count += 1
                                        return (
                                            <tr key={'extraction' + extraction.id + `${index}`} style={{ height: 120, maxHeight: 120 }}>
                                                <td>{count}</td>
                                                <td style={{ verticalAlign: 'middle' }}>{extraction.code}</td>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <QRCode value={extraction.code!} size={50}></QRCode>
                                                </td>
                                                <td style={{ lineHeight: 1.4 }}>
                                                    <div>{extraction.sample?.rack?.locationCode}</div>
                                                    <div>{extraction.sample?.tubeLocation}</div>
                                                </td>
                                                <td></td>
                                                <td>
                                                    {form.object.note?.split('\n').map((s) => (
                                                        <div key={s}>{s}</div>
                                                    ))}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </A4>
                    )
                })}
        </>
    )
}

export default withRouter(ExperimentSheetPage)
